
































































































































































import { toRefs, ref, reactive, defineComponent } from "@vue/composition-api";
import { useMainStore } from "@/store/storage";
import { db } from "../firebase/firebase";
import { Zone } from "@/interfaces/interfaces";

export default defineComponent({
  name: "InspectionZone",
  props: {},
  setup(props, { root }) {
    const main = useMainStore();
    const areaform = ref(null);
    const comeHere = ref(null);
    const state = reactive({
      id: "",
      zone: "",
      equipmentType: "",
      hasFailedList: true,
      hasInspectionBook: true,
      hasSurveyReport: true,
      color: "rgba(96,125,139,0.2)",
      page: root.$route.params.page,
      valid: false,
      showform: true,
      showmessage: false,
      showProgress: false,
      message: "",
      messageClass: "success",
      inspectionZones: [],
      swatches: [
        ["#F44336", "#E91E63", "#FF9800"],
        ["#FFEB3B", "#9C27B0", "#795548"],
        ["#4CAF50", "#673AB7", "#607D8B"],
        ["#00BCD4", "#009688", "#9E9E9E"],
        ["#2196F3", "#CDDC39", "#000000"]
      ]
    });

    interface VForm extends HTMLFormElement {
      validate(): boolean;
    }
    function resetForm(): void {
      // const formElement = (areaform.value as ( unknown | null | HTMLFormElement  ));
      const formElement = (areaform.value as unknown) as VForm;
      console.log(formElement.validate());
      formElement?.reset();
      formElement?.resetValidation();
    }

    // function getAreas() {
    //   // console.log("HEY PINIA");
    //   db.collection("InspectionZones")
    //     .orderBy("zone", "asc")
    //     .onSnapshot((snapshot) => {
    //       // eslint-disable-next-line
    //       const zoneList: any = [];
    //       snapshot.forEach((item) => {
    //         const obj = { id: item.id, ...item.data() };
    //         zoneList.push(obj);
    //         // console.log(obj);
    //       });
    //       main.state.inspectionZones = zoneList;
    //     });
    // }

    // getAreas();

    // console.log("MAIN", main.state.inspectionZones);

    function hideMessage() {
      setTimeout(() => {
        state.showmessage = false;
        state.showProgress = false;
      }, 3000);
    }

    function saveArea() {
      if (state.valid) {
        const order = new Date().valueOf();
        const data: Zone = {
          order,
          zone: state.zone,
          equipmentType: state.equipmentType,
          color: state.color,
          hasFailedList: state.hasFailedList,
          hasInspectionBook: state.hasInspectionBook,
          hasSurveyReport: state.hasSurveyReport
        };
        if (state.zone) {
          state.valid = false;
          state.showProgress = true;

          console.log(!!state.id);

          if (!!state.id as boolean) {
            db.collection("InspectionZones")
              .doc(state.id)
              .update(data)
              .then(() => {
                console.log("Data Updated");
                state.showmessage = true;
                state.showProgress = false;
                state.message = "Zone updated successfully saved";
                state.messageClass = "success";
                resetForm();

                hideMessage();
              })
              .catch();
          } else {
            db.collection("InspectionZones")
              .add(data)
              .then(() => {
                // console.log(state.page, state.zone, state.equipmentType, order);
                state.showmessage = true;
                state.showProgress = false;
                state.message = "Zone record successfully saved";
                state.messageClass = "success";
                //@ts-ignore
                areaform.value.reset();
                //@ts-ignore
                areaform.value.resetValidation();

                hideMessage();
              })
              .catch((e) => {
                console.log(e);
              });
          }
        } else {
          // alert("Provide Zone");
          state.showmessage = true;
          state.showProgress = false;
          state.message = "Something was wrong with the Zone name";
          state.messageClass = "error";
          hideMessage();
        }
      }
    }

    function editItem(item: Zone): void {
      state.id = item.id as string;
      state.zone = item.zone;
      state.equipmentType = item.equipmentType;
      state.color = item.color;
      state.showform = true;

      root.$vuetify.goTo("#comeHere");
    }

    function deleteItem(item: Zone): void {
      if (confirm("Are you sure you want to delete this?")) {
        db.collection("InspectionZones")
          .doc(item.id)
          .delete()
          .then(() => {
            resetForm();
            console.log("ITEM DELETED");
          });
      }
    }

    interface Color {
      rgba: {
        r: string;
        g: string;
        b: string;
        a: string;
      };
    }
    function colorString(color: Color): string {
      if (color !== undefined) {
        // console.log(color);
        // console.log(
        //   "rgba(" +
        //     color.rgba.r +
        //     "," +
        //     color.rgba.g +
        //     "," +
        //     color.rgba.b +
        //     "," +
        //     color.rgba.a +
        //     " )"
        // );
        return ("rgba(" +
          color.rgba.r +
          "," +
          color.rgba.g +
          "," +
          color.rgba.b +
          "," +
          color.rgba.a +
          " )") as string;
      }
      return "rgba(96,125,139,0.2)";
    }

    return {
      saveArea,
      areaform,
      comeHere,
      editItem,
      resetForm,
      deleteItem,
      colorString,
      main: main.state,
      ...toRefs(state)
    };
  }
});
